import { hasAds } from 'mk/bazaar/common/userUtils';
import { BrandDaysPosts } from 'mk2/apps/home/components/BrandDaysPosts';
import ContestPosts from 'mk2/apps/home/components/ContestPosts';
import HomeBaseBannerComponent from 'mk2/apps/home/components/HomeBaseBannerComponent';
import { Props } from 'mk2/apps/home/containers/Home2/Home2Page';
import { FooterNarrow } from 'mk2/components/Footer';
import { AdSlot } from 'mk2/containers/AdSlot/AdSlot';
import { isSuccess } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './Home2Right.mscss';

const noop = () => { /* noop */ };

export class Home2Right extends React.PureComponent<Props> {

    public render() {
        const {
            brandDaysCampaign,
            brandDaysPosts,
            contestPosts,
            forumPosts,
            homePosts,
            isMobile,
            loadingState,
            location,
            requestUser,
        } = this.props;

        const showBrandDays = !!brandDaysCampaign && brandDaysPosts.length > 0 && hasAds(requestUser);

        return (
            <div className={styles.Home2Right}>
                {(isSuccess(loadingState) || forumPosts.length > 0) && showBrandDays && (
                    <BrandDaysPosts
                        className={styles.Home2Right__brandDaysPosts}
                        brandDaysCampaign={brandDaysCampaign}
                        brandDaysPosts={brandDaysPosts}
                    />
                )}
                {!isMobile && (
                    <AdSlot
                        zone={'Homepage2 - NativeRectangle 1 (Desktop)'}
                        location={location}
                        marginTopWithAd={10}
                        marginBottomWithAd={10}
                    />
                )}
                {isSuccess(loadingState) || homePosts.length ? (
                    <>
                        {!isMobile &&
                            <HomeBaseBannerComponent
                                showEshopHome={false}
                                className={styles.Home2Right__baseLink}
                                requestUser={requestUser}
                            />
                        }
                        {!isMobile && contestPosts.length > 0 && (
                            <ContestPosts
                                className={styles.Home2Right__contestPosts}
                                posts={contestPosts}
                            />
                        )}
                    </>
                ) : null}

                {!isMobile && (
                    <div className={styles.Home2Right__footerNarrow}>
                        <FooterNarrow
                            onItemClick={noop}
                            isMobile={isMobile}
                        />
                    </div>
                )}
            </div>
        );
    }
}
